var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarInactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 79,
    viewBox: "0 0 83 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0728 2.69488C39.6274 0.111604 43.3726 0.111605 44.9272 2.69488L55.9321 20.9812C56.4906 21.9093 57.4016 22.5712 58.4568 22.8156L79.2489 27.631C82.1862 28.3113 83.3435 31.8732 81.367 34.15L67.3764 50.2671C66.6664 51.085 66.3184 52.156 66.412 53.2351L68.2573 74.4976C68.518 77.5013 65.4881 79.7026 62.712 78.5265L43.0604 70.201C42.063 69.7785 40.937 69.7785 39.9396 70.201L20.288 78.5265C17.5119 79.7026 14.482 77.5013 14.7427 74.4976L16.588 53.2351C16.6816 52.156 16.3337 51.085 15.6236 50.2671L1.63296 34.15C-0.34348 31.8732 0.813846 28.3113 3.7511 27.631L24.5432 22.8156C25.5984 22.5712 26.5094 21.9093 27.0679 20.9812L38.0728 2.69488Z",
    fill: "#C9C9C9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarInactive);
export default __webpack_public_path__ + "static/media/star_inactive.6a35afb6d3648580868a05d1b7033ff5.svg";
export { ForwardRef as ReactComponent };